import React, { useEffect, useState } from "react";
import { BiLogOut, BiSolidDashboard } from "react-icons/bi";
import { RiSettingsFill } from "react-icons/ri";
import {
  blackTrade,
  blackWallet,
  darkLogo,
  logo,
  whiteTrade,
  whiteWallet,
} from "../assets/images/index";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useAuth } from "../context/auth-context";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "../context/user-context";
import { FaClock } from "react-icons/fa";

const Dashboard = () => {
  const { logout } = useAuth();
  const { setIsOpen, isOpen, theme } = useUser();

  const [activeStatus, setActiveStatus] = useState<number>(1);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setActiveStatus(1);
    } else if (location.pathname === "/wallet") {
      setActiveStatus(2);
    } else if (location.pathname === "/trade") {
      setActiveStatus(3);
    } else if (location.pathname === "/settings") {
      setActiveStatus(4);
    } else if (location.pathname === "/activity") {
      setActiveStatus(5);
    } else if (location.pathname === "/cards") {
      setActiveStatus(6);
    } else {
      setActiveStatus(1);
    }
  }, [activeStatus, location.pathname]);

  return (
    <div className="lgss:w-[20%] bg-side_bar_black dark:bg-[#0D0D0D]">
      <div className="hidden lgss:flex lgss:flex-col h-screen justify-between  w-full font-manrope bg-white dark:bg-[#0D0D0D] pt-[35px]  text-white">
        <div className=" mt-12 lgss:mt-0 w-full">
          <div className="flex justify-start ml-10 items-center w-full mb-24">
            {theme === "light" ? (
              <img src={darkLogo} className="w-[90px] h-[25px]" alt="logo" />
            ) : (
              <img src={logo} className="w-[90px] h-[25px]" alt="logo" />
            )}
          </div>
          <Link
            to="/dashboard"
            className={
              activeStatus === 1
                ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[60px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                : "flex cursor-pointer justify-between  h-[60px] px-4  items-center"
            }
          >
            <div className="flex gap-3 justify-center w-[70%]  items-center pl-12">
              <div>
                <BiSolidDashboard
                  className={
                    activeStatus === 1
                      ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                      : "dark:text-gray-50 text-[#13181B] font-normal text-[24px]"
                  }
                />
              </div>
              <h4
                className={
                  activeStatus === 1
                    ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                    : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                }
              >
                Dashboard
              </h4>
            </div>
            {activeStatus === 1 && (
              <div className="bg-white h-6 w-[3px] transform transition-transform duration-300" />
            )}
          </Link>
          <Link
            to="/wallet"
            className={
              activeStatus === 2
                ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[60px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                : "flex cursor-pointer justify-between  h-[60px] px-4  items-center"
            }
          >
            <div className="flex gap-3 justify-center w-[70%] items-center pl-2">
              <div className="w-[24px] h-[24px] ">
                <img
                  src={`${
                    theme === "dark"
                      ? whiteWallet
                      : activeStatus === 2
                      ? whiteWallet
                      : blackWallet
                  }`}
                  alt=""
                />
              </div>

              {/* <BsCreditCardFill
                className={
                  activeStatus === 2
                    ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                    : "dark:text-text_feint text-[#13181B] font-normal text-[24px]"
                }
              /> */}
              <h4
                className={
                  activeStatus === 2
                    ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                    : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                }
              >
                Wallet
              </h4>
            </div>
            {activeStatus === 2 && (
              <div className="bg-white h-6 w-[3px] transform transition-transform duration-300" />
            )}
          </Link>
          <Link
            to="/trade"
            className={
              activeStatus === 3
                ? "flex cursor-pointer justify-between transform transition-transform duration-300 h-[60px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                : "flex cursor-pointer justify-between  h-[60px] px-4  items-center"
            }
          >
            <div className="flex gap-3 justify-center w-[70%] items-center ">
              <div className="w-[24px] h-[24px] ">
                <img
                  src={`${
                    theme === "dark"
                      ? whiteTrade
                      : activeStatus === 3
                      ? whiteTrade
                      : blackTrade
                  }`}
                  alt=""
                />
              </div>
              <h4
                className={
                  activeStatus === 3
                    ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                    : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                }
              >
                Trade
              </h4>
            </div>
            {activeStatus === 3 && (
              <div className="bg-white h-6 w-[3px] transform transition-transform duration-300" />
            )}
          </Link>
          <Link
            to="/activity"
            className={
              activeStatus === 5
                ? "flex cursor-pointer justify-between transform transition-transform duration-300 h-[60px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                : "flex cursor-pointer justify-between  h-[60px] px-4  items-center"
            }
          >
            <div className="flex gap-3 justify-center w-[70%] items-center pl-3">
              <FaClock
                className={
                  activeStatus === 5
                    ? "text-white font-bold  transform text-[20px] transition-transform duration-300"
                    : "dark:text-gray-50 text-[#13181B] font-normal text-[20px]"
                }
              />
              <h4
                className={
                  activeStatus === 5
                    ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                    : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                }
              >
                Activity
              </h4>
            </div>
            {activeStatus === 5 && (
              <div className="bg-white h-6 w-[3px] transform transition-transform duration-300" />
            )}
          </Link>
          <Link
            to="/settings"
            className={
              activeStatus === 4
                ? "flex cursor-pointer justify-between transform transition-transform duration-300 h-[60px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                : "flex cursor-pointer justify-between  h-[60px] px-4  items-center"
            }
          >
            <div className="flex gap-3 justify-center w-[70%] items-center pl-5">
              <RiSettingsFill
                className={
                  activeStatus === 4
                    ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                    : "dark:text-gray-50 text-[#13181B] font-normal text-[24px]"
                }
              />
              <h4
                className={
                  activeStatus === 4
                    ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                    : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                }
              >
                Settings
              </h4>
            </div>
            {activeStatus === 4 && (
              <div className="bg-white h-6 w-[3px] transform transition-transform duration-300" />
            )}
          </Link>
        </div>
        <div className="w-full mb-20 lgss:mb-32">
          {/* <div className="px-4 mt-16 w-full">
            <a
              href="https://wa.link/1zlp0c"
              target="_blank"
              rel="noreferrer"
              className="w-10/12 mx-auto rounded-xl h-[52px] flex items-center justify-center mt-4  text-[14px]  font-medium border-2 border-[#5EAE68] text-white"
            >
              Support Line
            </a>
          </div> */}
          {/* <div className="w-10/12 h-[0.5px]  mx-auto bg-gray-300 dark:bg-text_feint" />
          <div
            onClick={logout}
            className="flex justify-between cursor-pointer mt-4 h-[60px] px-4   items-center"
          >
            <div className="flex gap-2 justify-center items-center pl-4">
              <BiLogOut className="text-[#DF4E4E] font-bold text-[24px]" />
              <h4 className="font-semibold text-[#DF4E4E] text-[16px]">
                Logout
              </h4>
            </div>
          </div> */}
        </div>
      </div>
      {isOpen && (
        <div
          className={`absolute z-50 top-0 left-0  h-screen  bg-white dark:bg-[#0D0D0D] w-3/4 py-4 px-0 pt-10   transform transition-transform duration-300 ${
            isOpen ? "translate-x-0 " : "-translate-x-full"
          }`}
        >
          <div className="w-full flex flex-col justify-between h-full bg-white dark:bg-[#0D0D0D]">
            <div className=" bg-white mt-4 dark:bg-[#0D0D0D]">
              <div className="flex justify-between px-8 mb-16 items-center">
                <div className="flex justify-start ml-10 items-center w-full">
                  {theme === "light" ? (
                    <img
                      src={darkLogo}
                      className="w-[90px] h-[25px]"
                      alt="logo"
                    />
                  ) : (
                    <img src={logo} className="w-[90px] h-[25px]" alt="logo" />
                  )}
                </div>
                <AiOutlineCloseCircle
                  className="dark:text-text_feint text-black text-3xl"
                  onClick={() => setIsOpen((prev: any) => !prev)}
                />
              </div>
              <Link
                to="/dashboard"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className={
                  activeStatus === 1
                    ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[70px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                    : "flex cursor-pointer justify-between  h-[70px] px-4  items-center"
                }
              >
                <div className="flex gap-2 justify-center items-center pl-10">
                  <div>
                    <BiSolidDashboard
                      className={
                        activeStatus === 1
                          ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                          : "dark:text-gray-50 text-[#13181B]  font-normal text-[24px]"
                      }
                    />
                  </div>
                  <h4
                    className={
                      activeStatus === 1
                        ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                        : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                    }
                  >
                    Dashboard
                  </h4>
                </div>
                {activeStatus === 1 && (
                  <div className="bg-white h-8 w-[3px] transform transition-transform duration-300" />
                )}
              </Link>
              <Link
                to="/wallet"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className={
                  activeStatus === 2
                    ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[70px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                    : "flex cursor-pointer justify-between  h-[70px] px-4  items-center"
                }
              >
                <div className="flex gap-2 justify-center items-center pl-10">
                  <div className="w-[24px] h-[24px] ">
                    <img
                      src={`${
                        theme === "dark"
                          ? whiteWallet
                          : activeStatus === 3
                          ? whiteWallet
                          : blackWallet
                      }`}
                      alt=""
                    />
                  </div>
                  <h4
                    className={
                      activeStatus === 2
                        ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                        : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                    }
                  >
                    Wallet
                  </h4>
                </div>
                {activeStatus === 2 && (
                  <div className="bg-white h-8 w-[3px] transform transition-transform duration-300" />
                )}
              </Link>
              <Link
                to="/trade"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className={
                  activeStatus === 3
                    ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[70px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                    : "flex cursor-pointer justify-between  h-[70px] px-4  items-center"
                }
              >
                <div className="flex gap-2 justify-center items-center pl-10">
                  <div className="w-[24px] h-[24px] ">
                    <img
                      src={`${
                        theme === "dark"
                          ? whiteTrade
                          : activeStatus === 3
                          ? whiteTrade
                          : blackTrade
                      }`}
                      alt=""
                    />
                  </div>
                  <h4
                    className={
                      activeStatus === 3
                        ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                        : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                    }
                  >
                    Trade
                  </h4>
                </div>
                {activeStatus === 3 && (
                  <div className="bg-white h-8 w-[3px] transform transition-transform duration-300" />
                )}
              </Link>
              <Link
                to="/activity"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className={
                  activeStatus === 5
                    ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[70px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                    : "flex cursor-pointer justify-between   h-[70px] px-4  items-center"
                }
              >
                <div className="flex gap-2 justify-center items-center pl-10">
                  <FaClock
                    className={
                      activeStatus === 5
                        ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                        : "dark:text-gray-50 text-[#13181B]  font-normal text-[24px]"
                    }
                  />
                  <h4
                    className={
                      activeStatus === 5
                        ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                        : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                    }
                  >
                    Activity
                  </h4>
                </div>
                {activeStatus === 5 && (
                  <div className="bg-white h-8 w-[3px] transform transition-transform duration-300" />
                )}
              </Link>
              <Link
                to="/settings"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className={
                  activeStatus === 4
                    ? "flex cursor-pointer justify-between transform transition-transform duration-300  h-[70px] px-4 bg-[#095B97] dark:bg-[#1E1E1E]  items-center"
                    : "flex cursor-pointer justify-between  h-[70px] px-4  items-center"
                }
              >
                <div className="flex gap-2 justify-center items-center pl-10">
                  <RiSettingsFill
                    className={
                      activeStatus === 4
                        ? "text-white font-bold  transform text-[24px] transition-transform duration-300"
                        : "dark:text-gray-50 text-[#13181B]  font-normal text-[24px]"
                    }
                  />
                  <h4
                    className={
                      activeStatus === 4
                        ? "font-semibold text-[16px] text-white transform transition-transform duration-300"
                        : "font-normal text-[16px] dark:text-text_feint  text-gray-800"
                    }
                  >
                    Settings
                  </h4>
                </div>
                {activeStatus === 4 && (
                  <div className="bg-white h-8 w-[3px] transform transition-transform duration-300" />
                )}
              </Link>
            </div>
            <div className="w-full">
              {/* <div className="px-4  w-full">
                <a
                  href="https://wa.link/1zlp0c"
                  target="_blank"
                  rel="noreferrer"
                  className="w-10/12 md:w-1/3  mx-auto rounded-xl h-[56px] flex items-center justify-center mt-4  text-[14px]  font-medium border-2 border-[#5EAE68] text-white"
                >
                  Support Line
                </a>
              </div> */}
              {/* <div className="w-10/12 h-[0.5px]  mx-auto bg-gray-300 dark:bg-text_feint" />

              <div className="flex justify-between mt-4 h-[60px] px-8   items-center">
                <div
                  onClick={logout}
                  className="flex gap-2 cursor-pointer justify-center items-center pl-10"
                >
                  <BiLogOut className="text-[#DF4E4E] font-bold text-[24px]" />
                  <h4 className="font-semibold text-[#DF4E4E] text-[16px]">
                    Logout
                  </h4>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
